import React from 'react'
import { CustomText } from 'src/components'
import { useTranslation } from 'next-i18next'
import { ProjectImpact } from 'src/core/models'
import { ProjectDetailsCollapse } from '../index'
import ProjectImpactCard from './ProjectImpactCard/ProjectImpactCard'

interface PropsType { impacts: ProjectImpact[] }

const ProjectDetailsImpacts: React.FC<PropsType> = ({ impacts }) => {
  const { t } = useTranslation()

  return (
    <ProjectDetailsCollapse label={<CustomText label={t('Projects.Impacts')} strong/>}>
      {/* Impact List */}
      <div className='columns is-multiline'>
        {impacts.map((impact: ProjectImpact) => <div key={impact.id} className='column is-4'>
          <ProjectImpactCard impact={impact} />
        </div>)}
      </div>
    </ProjectDetailsCollapse>
  )
}

export default ProjectDetailsImpacts
